import "../../index60.css";
import { jsx as a, jsxs as s } from "react/jsx-runtime";
import { CloseLineIcon as S } from "@ifrc-go/icons";
import { _ as r } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import u from "../InlineLayout/index.js";
import L from "../../hooks/useSpacingToken.js";
const T = "_tab-layout_1xx1g_1", C = "_errored_1xx1g_17", P = "_color-variant-text_1xx1g_21", W = "_color-variant-primary_1xx1g_25", h = "_color-variant-secondary_1xx1g_29", w = "_style-variant-tab_1xx1g_33", B = "_active_1xx1g_42", I = "_style-variant-nav_1xx1g_54", j = "_style-variant-pill_1xx1g_64", O = "_style-variant-vertical_1xx1g_75", k = "_style-variant-vertical-compact_1xx1g_92", A = "_style-variant-step_1xx1g_106", F = "_completed_1xx1g_115", q = "_disabled_1xx1g_120", z = "_tab-wrapper_1xx1g_129", D = "_active-border_1xx1g_135", E = "_bottom-border_1xx1g_146", G = "_step-wrapper_1xx1g_152", H = "_dot_1xx1g_157", J = "_icon_1xx1g_167", K = "_dot-wrapper_1xx1g_178", M = "_before-line_1xx1g_183", Q = "_after-line_1xx1g_192", R = "_first-step_1xx1g_225", U = "_last-step_1xx1g_238", t = {
  tabLayout: T,
  errored: C,
  colorVariantText: P,
  colorVariantPrimary: W,
  colorVariantSecondary: h,
  styleVariantTab: w,
  active: B,
  styleVariantNav: I,
  styleVariantPill: j,
  styleVariantVertical: O,
  styleVariantVerticalCompact: k,
  styleVariantStep: A,
  completed: F,
  disabled: q,
  tabWrapper: z,
  activeBorder: D,
  bottomBorder: E,
  stepWrapper: G,
  dot: H,
  icon: J,
  dotWrapper: K,
  beforeLine: M,
  afterLine: Q,
  firstStep: R,
  lastStep: U
}, X = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary
}, Y = {
  tab: t.styleVariantTab,
  pill: t.styleVariantPill,
  step: t.styleVariantStep,
  nav: t.styleVariantNav,
  vertical: t.styleVariantVertical,
  "vertical-compact": t.styleVariantVerticalCompact
}, Z = {
  tab: 1,
  pill: 0,
  step: -1,
  nav: 0,
  vertical: 0,
  "vertical-compact": -1
};
function st(p) {
  const {
    colorVariant: _ = "primary",
    styleVariant: e = "nav",
    spacingOffset: d = Z[e],
    className: x,
    disabled: m,
    children: y,
    withoutPadding: v = !1,
    active: o,
    spacing: V,
    tabWrapperClassName: b,
    stepCompleted: n,
    isFirstStep: g,
    isLastStep: f,
    errored: c,
    ...N
  } = p, l = L({
    modes: ["padding-inline"],
    spacing: V,
    offset: -5
  }), i = /* @__PURE__ */ a(
    u,
    {
      ...N,
      withPadding: !(v || e === "vertical-compact" || e === "nav"),
      className: r(
        t.tabLayout,
        X[_],
        Y[e],
        n && t.completed,
        m && t.disabled,
        o && t.active,
        c && t.errored,
        x
      ),
      spacingOffset: d,
      withAdditionalInlinePadding: e === "pill",
      children: y
    }
  );
  return e === "tab" ? /* @__PURE__ */ s(
    "div",
    {
      className: r(
        t.tabWrapper,
        b,
        o && t.active
      ),
      children: [
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, l) }),
        i,
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, l) }),
        o && /* @__PURE__ */ a("div", { className: t.activeBorder })
      ]
    }
  ) : e === "step" ? /* @__PURE__ */ s(
    "div",
    {
      className: r(
        t.stepWrapper,
        o && t.active,
        n && t.completed,
        g && t.firstStep,
        f && t.lastStep
      ),
      role: "tab",
      children: [
        /* @__PURE__ */ s("div", { className: t.dotWrapper, children: [
          /* @__PURE__ */ a("div", { className: t.beforeLine }),
          /* @__PURE__ */ a("div", { className: t.dot, children: c && /* @__PURE__ */ a(S, { className: t.icon }) }),
          /* @__PURE__ */ a("div", { className: t.afterLine })
        ] }),
        i
      ]
    }
  ) : i;
}
export {
  st as default
};
